import styled from 'styled-components';

const StyledTitle = styled.h3`
  font-size: var(--heading-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--blue-dark);
  margin-bottom: 15px;
`;

const StyledText = styled.p`
  color: var(--black);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-base);

  a {
    color: var(--blue-base);
  }
`;

export { StyledTitle, StyledText };
